const MAIL_PROVIDER_LINKS: Record<string, string> = {
  'yandex.ru': 'https://mail.yandex.ru',
  'gmail.com': 'https://mail.google.com',
  'mail.ru': 'https://e.mail.ru',
  'inbox.ru': 'https://e.mail.ru',
  'bk.ru': 'https://e.mail.ru',
  'list.ru': 'https://e.mail.ru',
  'internet.ru': 'https://e.mail.ru',
}

/**
 * Возвращает ссылку на веб-интерфейс почтовика по адресу электронной почты.
 * Для доменов вне списка возвращает null.
 *
 * user@yandex.ru - https://mail.yandex.ru
 * user@gmail.com - https://mail.google.com
 * user@bk.ru     - https://e.mail.ru
 * user@corp.com  - null
 */
export const getMailProviderLink = (email: string): string | null => {
  const domain = email.trim().toLowerCase().split('@').pop()

  if (!domain) {
    return null
  }

  return MAIL_PROVIDER_LINKS[domain] ?? null
}
